var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.745 38.8501C1.94802 39.0293 1.2554 38.8411 0.667158 38.2854C0.0789111 37.7296 -0.120334 37.0753 0.0694233 36.3223L2.34651 26.0501L13.6181 36.6988L2.745 38.8501ZM13.6181 36.6988L2.34651 26.0501L28.4191 1.41813C29.292 0.593477 30.3736 0.181152 31.664 0.181152C32.9543 0.181152 34.0359 0.593477 34.9088 1.41813L39.6907 5.93577C40.5636 6.76042 41 7.78227 41 9.00132C41 10.2204 40.5636 11.2422 39.6907 12.0669L13.6181 36.6988ZM31.664 4.42989L8.09614 26.6954L12.9349 31.2669L36.5028 9.00132L31.664 4.42989Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.7b5cab44c397c042340bf31b0b9dcf2a.svg";
export { ForwardRef as ReactComponent };